import { http } from '@/api/instance';

export const exportAPI: Record<keyof Events, ({ ...params }: Record<string, string | number>) => Promise<File>> = {
  export_leads: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/leads', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
  export_accounts: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/accounts', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
  export_classes: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/classes', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
  export_contracts: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/contracts', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
  export_payments: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/payments', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
  export_receipts: ({ ...params }: Record<string, string | number>) =>
    http
      .get<File>('/api/export/receipts', {
        params,
        responseType: 'blob',
      })
      .then(({ data }) => data),
};
